import React from "react";
import { Modal } from "react-bootstrap";

function ModalUploadSuccess(props) {

  return (
    <Modal show={props.show}>
      <Modal.Header>
        <h2 className="text-center">Certificado Cadastrado!</h2>
      </Modal.Header>
      <Modal.Body>
        <p className="lead">
          Seu certificado digital está cadastrado e vencerá <strong>{props.certExpireDate}</strong>, mas fique tranquilo(a),
          entraremos em contato com você para realizarmos a sua renovação.
        </p>
        <button onClick={()=> {
          props.closeMe()
          window.location.reload()
        }} className="btn ml-auto">
          Fechar
        </button>
      </Modal.Body>
    </Modal>
  );
}
export default ModalUploadSuccess;


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/digital-certificate/components/modals/success.jsx